var wasm;const __exports = {};

/**
* @returns {number}
*/
__exports. get_rng_values_size = function() {
    var ret = wasm.get_rng_values_size();
    return ret >>> 0;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_rng_value = function(i, v) {
    wasm.set_rng_value(i, v);
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_sk_byte = function(i, v) {
    wasm.set_sk_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_sk_byte = function(i) {
    var ret = wasm.get_sk_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_pk_byte = function(i, v) {
    wasm.set_pk_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_pk_byte = function(i) {
    var ret = wasm.get_pk_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_sig_byte = function(i, v) {
    wasm.set_sig_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_sig_byte = function(i) {
    var ret = wasm.get_sig_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_msg_byte = function(i, v) {
    wasm.set_msg_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_msg_byte = function(i) {
    var ret = wasm.get_msg_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_ct_byte = function(i, v) {
    wasm.set_ct_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_ct_byte = function(i) {
    var ret = wasm.get_ct_byte(i);
    return ret;
}

/**
* @returns {number}
*/
__exports. get_rng_next_count = function() {
    var ret = wasm.get_rng_next_count();
    return ret >>> 0;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_poly_byte = function(i, v) {
    wasm.set_poly_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_poly_byte = function(i) {
    var ret = wasm.get_poly_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_msk_byte = function(i, v) {
    wasm.set_msk_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_msk_byte = function(i) {
    var ret = wasm.get_msk_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_mpk_byte = function(i, v) {
    wasm.set_mpk_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_mpk_byte = function(i) {
    var ret = wasm.get_mpk_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_mc_byte = function(i, v) {
    wasm.set_mc_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_mc_byte = function(i) {
    var ret = wasm.get_mc_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_skshare_byte = function(i, v) {
    wasm.set_skshare_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_skshare_byte = function(i) {
    var ret = wasm.get_skshare_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_pkshare_byte = function(i, v) {
    wasm.set_pkshare_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_pkshare_byte = function(i) {
    var ret = wasm.get_pkshare_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} from_node
* @param {number} to_node
* @param {number} v
*/
__exports. set_bivar_row_byte = function(i, from_node, to_node, v) {
    wasm.set_bivar_row_byte(i, from_node, to_node, v);
}

/**
* @param {number} i
* @param {number} from_node
* @param {number} to_node
* @returns {number}
*/
__exports. get_bivar_row_byte = function(i, from_node, to_node) {
    var ret = wasm.get_bivar_row_byte(i, from_node, to_node);
    return ret;
}

/**
* @param {number} i
* @param {number} from_node
* @param {number} v
*/
__exports. set_bivar_commitments_byte = function(i, from_node, v) {
    wasm.set_bivar_commitments_byte(i, from_node, v);
}

/**
* @param {number} i
* @param {number} from_node
* @returns {number}
*/
__exports. get_bivar_commitments_byte = function(i, from_node) {
    var ret = wasm.get_bivar_commitments_byte(i, from_node);
    return ret;
}

/**
* @param {number} i
* @param {number} node_index
* @param {number} v
*/
__exports. set_bivar_sks_byte = function(i, node_index, v) {
    wasm.set_bivar_sks_byte(i, node_index, v);
}

/**
* @param {number} i
* @param {number} node_index
* @returns {number}
*/
__exports. get_bivar_sks_byte = function(i, node_index) {
    var ret = wasm.get_bivar_sks_byte(i, node_index);
    return ret;
}

/**
* @param {number} i
* @param {number} node_index
* @param {number} v
*/
__exports. set_bivar_pks_byte = function(i, node_index, v) {
    wasm.set_bivar_pks_byte(i, node_index, v);
}

/**
* @param {number} i
* @param {number} node_index
* @returns {number}
*/
__exports. get_bivar_pks_byte = function(i, node_index) {
    var ret = wasm.get_bivar_pks_byte(i, node_index);
    return ret;
}

/**
* @param {number} i
* @param {number} sig_index
* @param {number} v
*/
__exports. set_signature_share_byte = function(i, sig_index, v) {
    wasm.set_signature_share_byte(i, sig_index, v);
}

/**
* @param {number} i
* @param {number} sig_index
* @returns {number}
*/
__exports. get_signature_share_byte = function(i, sig_index) {
    var ret = wasm.get_signature_share_byte(i, sig_index);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_share_indexes = function(i, v) {
    wasm.set_share_indexes(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_share_indexes = function(i) {
    var ret = wasm.get_share_indexes(i);
    return ret >>> 0;
}

/**
* @param {number} i
* @param {number} share_index
* @param {number} v
*/
__exports. set_decryption_shares_byte = function(i, share_index, v) {
    wasm.set_decryption_shares_byte(i, share_index, v);
}

/**
* @param {number} i
* @param {number} share_index
* @returns {number}
*/
__exports. get_decryption_shares_byte = function(i, share_index) {
    var ret = wasm.get_decryption_shares_byte(i, share_index);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_base32z_byte = function(i, v) {
    wasm.set_base32z_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_base32z_byte = function(i) {
    var ret = wasm.get_base32z_byte(i);
    return ret;
}

/**
* @param {number} i
* @param {number} v
*/
__exports. set_unbase32z_byte = function(i, v) {
    wasm.set_unbase32z_byte(i, v);
}

/**
* @param {number} i
* @returns {number}
*/
__exports. get_unbase32z_byte = function(i) {
    var ret = wasm.get_unbase32z_byte(i);
    return ret;
}

/**
*/
__exports. derive_pk_from_sk = function() {
    wasm.derive_pk_from_sk();
}

/**
* @param {number} msg_size
*/
__exports. sign_msg = function(msg_size) {
    wasm.sign_msg(msg_size);
}

/**
* @param {number} msg_size
* @returns {boolean}
*/
__exports. verify = function(msg_size) {
    var ret = wasm.verify(msg_size);
    return ret !== 0;
}

/**
* @param {number} msg_size
* @returns {number}
*/
__exports. encrypt = function(msg_size) {
    var ret = wasm.encrypt(msg_size);
    return ret >>> 0;
}

/**
* @param {number} ct_size
* @returns {number}
*/
__exports. decrypt = function(ct_size) {
    var ret = wasm.decrypt(ct_size);
    return ret >>> 0;
}

/**
* @param {number} threshold
*/
__exports. generate_poly = function(threshold) {
    wasm.generate_poly(threshold);
}

/**
* @param {number} poly_size
* @returns {number}
*/
__exports. get_poly_degree = function(poly_size) {
    var ret = wasm.get_poly_degree(poly_size);
    return ret >>> 0;
}

/**
* @param {number} mc_size
* @returns {number}
*/
__exports. get_mc_degree = function(mc_size) {
    var ret = wasm.get_mc_degree(mc_size);
    return ret >>> 0;
}

/**
* @param {number} poly_size
*/
__exports. derive_master_key = function(poly_size) {
    wasm.derive_master_key(poly_size);
}

/**
* @param {number} i
* @param {number} poly_size
*/
__exports. derive_key_share = function(i, poly_size) {
    wasm.derive_key_share(i, poly_size);
}

/**
* @param {number} threshold
* @param {number} total_nodes
*/
__exports. generate_bivars = function(threshold, total_nodes) {
    wasm.generate_bivars(threshold, total_nodes);
}

/**
* @param {number} total_signatures
* @param {number} commitment_size
*/
__exports. combine_signature_shares = function(total_signatures, commitment_size) {
    wasm.combine_signature_shares(total_signatures, commitment_size);
}

/**
* @param {number} share_index
* @param {number} ct_size
* @returns {number}
*/
__exports. create_decryption_share = function(share_index, ct_size) {
    var ret = wasm.create_decryption_share(share_index, ct_size);
    return ret >>> 0;
}

/**
* @param {number} total_decryption_shares
* @param {number} commitment_size
* @param {number} ct_size
* @returns {number}
*/
__exports. combine_decryption_shares = function(total_decryption_shares, commitment_size, ct_size) {
    var ret = wasm.combine_decryption_shares(total_decryption_shares, commitment_size, ct_size);
    return ret >>> 0;
}

/**
* @param {number} unbase32z_size
* @returns {number}
*/
__exports. base32z_encode = function(unbase32z_size) {
    var ret = wasm.base32z_encode(unbase32z_size);
    return ret >>> 0;
}

/**
* @param {number} base32z_size
* @returns {number}
*/
__exports. base32z_decode = function(base32z_size) {
    var ret = wasm.base32z_decode(base32z_size);
    return ret >>> 0;
}



      function init(wasm_path) {
          const fetchPromise = fetch(wasm_path);
          let resultPromise;
          if (typeof WebAssembly.instantiateStreaming === 'function') {
              resultPromise = WebAssembly.instantiateStreaming(fetchPromise, { './threshold_crypto_wasm_bridge_bg.js': __exports });
          } else {
              resultPromise = fetchPromise
              .then(response => response.arrayBuffer())
              .then(buffer => WebAssembly.instantiate(buffer, { './threshold_crypto_wasm_bridge_bg.js': __exports }));
          }
          return resultPromise.then(({instance}) => {
              wasm = init.wasm = instance.exports;
              __exports.wasm = wasm;
              return;
          });
      };
      function init_node(wasm_path) {
          const fs = require('fs');
          return new Promise(function(resolve, reject) {
              fs.readFile(__dirname + wasm_path, function(err, data) {
                  if (err) {
                      reject(err);
                  } else {
                      resolve(data.buffer);
                  }
              });
          })
          .then(data => WebAssembly.instantiate(data, { './threshold_crypto_wasm_bridge_bg': __exports }))
          .then(({instance}) => {
              wasm = init.wasm = instance.exports;
              __exports.wasm = wasm;
              return;
          });
      }
      const wasm_bindgen = Object.assign(false ? init_node : init, __exports);
      module.exports = function loadWASMBundle(bundle) {
            return wasm_bindgen(bundle).then(() => __exports)
      }
    